export const th: { [k: string]: string } = {
  
}
export const thTH_nonRedundent: { [k: string]: string } = {
  // this is not actual slug, it;s simplified
  
}

export const spotlightThTH: {
  [k: string]: string
} = {
  
}
